var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('QuizContentForm',_vm._g({attrs:{"data":_vm.data,"title":_vm.$t('QUIZZES.TITLE.TYPED_ANSWER'),"showManualCheck":_vm.showManualCheck}},_vm.$listeners))],1)}
var staticRenderFns = []

export { render, staticRenderFns }